import {
  Home,
  Box,
  DollarSign,
  Tag,
  Clipboard,
  Camera,
  AlignLeft,
  UserPlus,
  Users,
  Chrome,
  BarChart,
  Settings,
  Archive,
  LogIn,
  MessageCircle,
} from "react-feather";

export const MENUITEMSFORADMIN = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: Home,
    type: "link",
    badgeType: "primary",
    active: false,
  },
  {
    title: "Cash in/Cash out",
    icon: DollarSign,
    type: "sub",
    active: false,
    children: [
      {
        path: "/expense/daily-expense",
        title: new Date().toDateString(),
        type: "link",
      },
      {
        path: "/expense/expense-history",
        title: "History",
        type: "link",
      },

      {
        path: "/expense/office",
        title: "Office",
        type: "link",
      },

      {
        path: "/expense/salary",
        title: "Salary",
        type: "link",
      },
      {
        path: "/expense/refunds",
        title: "Refund",
        type: "link",
      },
      {
        path: "/expense/daily-cost",
        title: "Daily Cost",
        type: "link",
      },
      {
        path: "/expense/lot-transport",
        title: "Transport",
        type: "link",
      },
      {
        path: "/expense/courier",
        title: "Courier Charge",
        type: "link",
      },
      {
        path: "/expense/shipping",
        title: "Shipping",
        type: "link",
      },
      {
        path: "/expense/boosting",
        title: "Boosting/Promotion",
        type: "link",
      },
      {
        path: "/expense/buy-products",
        title: "Buy Products",
        type: "link",
      },
      {
        path: "/expense/invest",
        title: "Invest",
        type: "link",
      },

      {
        title: "Loans",
        type: "sub",
        active: false,
        children: [
          {
            title: "Monthly",
            type: "link",
            path: "/expense/loans",
          },
          {
            title: "Customer wise",
            type: "link",
            path: "/expense/loans-by-customers",
          },
        ],
      },
      {
        path: "/expense/order",
        title: "All Sells",
        type: "link",
      },
      {
        path: "/expense/employee",
        title: "Employee",
        type: "link",
      },
    ],
  },
  {
    title: "Cash in/out History",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      {
        path: "/expense/approve-expense",
        title: "Pending",
        type: "link",
      },
      {
        path: "/expense/expense-history",
        title: "Monthly",
        type: "link",
      },

      {
        path: "/expense/office",
        title: "Office",
        type: "link",
      },
      {
        path: "/expense/salary",
        title: "Salary",
        type: "link",
      },
      {
        path: "/expense/refunds",
        title: "Refund",
        type: "link",
      },

      {
        path: "/expense/daily-cost",
        title: "Daily Cost",
        type: "link",
      },
      {
        path: "/expense/lot-transport",
        title: "Transport",
        type: "link",
      },
      {
        path: "/expense/courier",
        title: "Courier Charge",
        type: "link",
      },
      {
        path: "/expense/shipping",
        title: "Shipping",
        type: "link",
      },
      {
        path: "/expense/boosting",
        title: "Boosting/Promotion",
        type: "link",
      },
      {
        path: "/expense/buy-products",
        title: "Buy Products",
        type: "link",
      },
      {
        path: "/expense/invest",
        title: "Invest",
        type: "link",
      },
      {
        title: "Loans",
        type: "sub",
        active: false,
        children: [
          {
            title: "Monthly",
            type: "link",
            path: "/expense/loans",
          },
          {
            title: "Customer wise",
            type: "link",
            path: "/expense/loans-by-customers",
          },
        ],
      },
      {
        path: "/expense/order",
        title: "All Sells",
        type: "link",
      },
      {
        path: "/expense/employee",
        title: "Employee",
        type: "link",
      },
    ],
  },
  {
    title: "Cash Summary",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      {
        path: "/cash-summary",
        title: "Monthly",
        type: "link",
      },
    ],
  },
  {
    path: "/messages",
    title: "Messages",
    icon: MessageCircle,
    type: "link",
    badgeType: "primary",
    active: false,
  },
  {
    title: "Products",
    icon: Box,
    type: "sub",
    active: false,
    children: [
      {
        path: "/products/physical/all-products",
        title: "All Products",
        type: "link",
      },

      {
        path: "/products/physical/add-product",
        title: "Add Product",
        type: "link",
      },
      {
        path: "/products/physical/brands",
        title: "Brands",
        type: "link",
      },
      {
        path: "/products/physical/categories",
        title: "Categories",
        type: "link",
      },
      {
        path: "/products/physical/campaigns",
        title: "Campaigns",
        type: "link",
      },
      {
        path: "/products/physical/banners",
        title: "Banners",
        type: "link",
      },
      {
        path: "/products/physical/shop-by-concern",
        title: "Shop By Concern",
        type: "link",
      },
      {
        path: "/products/physical/attributes",
        title: "Attributes",
        type: "link",
      },
      {
        path: "/products/physical/reviews",
        title: "Reviews",
        type: "link",
      },
      {
        path: "/products/physical/reviews-screenshot",
        title: "Review Screenshot",
        type: "link",
      },
      {
        path: "/products/physical/announcements",
        title: "Announcements",
        type: "link",
      },
    ],
  },
  {
    title: "Coupons",
    icon: Box,
    type: "sub",
    active: false,
    children: [
      {
        path: "/coupons/physical/all-coupons",
        title: "All Coupons",
        type: "link",
      },
    ],
  },

  {
    title: "Orders",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      { path: "/orders/Processing", title: "Processing", type: "link" },
      { path: "/orders/Confirmed", title: "Confirmed", type: "link" },
      { path: "/orders/Packing", title: "Packing", type: "link" },
      { path: "/orders/On the way", title: "On the way", type: "link" },
      {
        path: "/orders/Delivered",
        title: "Delivered",
        type: "link",
      },
      {
        path: "/orders/Partial Delivered",
        title: "Partial Delivered",
        type: "link",
      },
      {
        path: "/orders/Cancelled",
        title: "Cancelled",
        type: "link",
      },
      {
        path: "/orders/All Orders",
        title: "All Orders",
        type: "link",
      },
    ],
  },
  {
    title: "Blogs",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [{ path: "/blogs", title: "Blog Post/Article", type: "link" }],
  },

  // {
  //     title: 'Media', path: '/media', icon: Camera, type: 'link', active: false
  // },
  // {
  //     title: 'Menus', icon: AlignLeft, type: 'sub', active: false, children: [
  //         { path: '/menus/list-menu', title: 'List Menu', type: 'link' },
  //         { path: '/menus/create-menu', title: 'Create Menu', type: 'link' },
  //     ]
  // },
  {
    title: "Users",
    icon: UserPlus,
    type: "sub",
    active: false,
    children: [
      { path: "/users/list-user", title: "User List", type: "link" },
      // { path: '/users/create-user', title: 'Create User', type: 'link' },
    ],
  },

  {
    title: "Admins",
    icon: UserPlus,
    type: "sub",
    active: false,
    children: [
      { path: "/admins/list-admin", title: "All Admins", type: "link" },
      // { path: '/users/create-user', title: 'Create User', type: 'link' },
    ],
  },

  {
    title: "Register a manager",
    path: "/",
    icon: LogIn,
    type: "link",
    active: false,
  },
];
export const MENUITEMSFOREMPLOYEE = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: Home,
    type: "link",
    badgeType: "primary",
    active: false,
  },

  {
    path: "/messages",
    title: "Messages",
    icon: MessageCircle,
    type: "link",
    badgeType: "primary",
    active: false,
  },
  {
    title: "Products",
    icon: Box,
    type: "sub",
    active: false,
    children: [
      {
        path: "/products/physical/all-products",
        title: "All Products",
        type: "link",
      },

      {
        path: "/products/physical/add-product",
        title: "Add Product",
        type: "link",
      },
      {
        path: "/products/physical/brands",
        title: "Brands",
        type: "link",
      },
      {
        path: "/products/physical/categories",
        title: "Categories",
        type: "link",
      },

      {
        path: "/products/physical/attributes",
        title: "Attributes",
        type: "link",
      },
      {
        path: "/products/physical/reviews",
        title: "Reviews",
        type: "link",
      },
      {
        path: "/products/physical/reviews-screenshot",
        title: "Review Screenshot",
        type: "link",
      },
    ],
  },

  {
    title: "Orders",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      { path: "/orders/Processing", title: "Processing", type: "link" },
      { path: "/orders/Confirmed", title: "Confirmed", type: "link" },
      { path: "/orders/Packing", title: "Packing", type: "link" },
      { path: "/orders/On the way", title: "On the way", type: "link" },
      {
        path: "/orders/Delivered",
        title: "Delivered",
        type: "link",
      },
      {
        path: "/orders/Partial Delivered",
        title: "Partial Delivered",
        type: "link",
      },
      {
        path: "/orders/Cancelled",
        title: "Cancelled",
        type: "link",
      },
      {
        path: "/orders/All Orders",
        title: "All Orders",
        type: "link",
      },
    ],
  },

  {
    title: "Users",
    icon: UserPlus,
    type: "sub",
    active: false,
    children: [
      { path: "/users/list-user", title: "User List", type: "link" },
      // { path: '/users/create-user', title: 'Create User', type: 'link' },
    ],
  },
];

export const MENUITEMSFORACCOUNTS = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: Home,
    type: "link",
    badgeType: "primary",
    active: false,
  },
  {
    title: "Cash in/Cash out",
    icon: DollarSign,
    type: "sub",
    active: false,
    children: [
      {
        path: "/expense/daily-expense",
        title: new Date().toDateString(),
        type: "link",
      },
      {
        path: "/expense/expense-history",
        title: "History",
        type: "link",
      },

      {
        path: "/expense/office",
        title: "Office",
        type: "link",
      },

      {
        path: "/expense/salary",
        title: "Salary",
        type: "link",
      },
      {
        path: "/expense/refunds",
        title: "Refund",
        type: "link",
      },
      {
        path: "/expense/daily-cost",
        title: "Daily Cost",
        type: "link",
      },
      {
        path: "/expense/lot-transport",
        title: "Transport",
        type: "link",
      },
      {
        path: "/expense/courier",
        title: "Courier Charge",
        type: "link",
      },
      {
        path: "/expense/shipping",
        title: "Shipping",
        type: "link",
      },
      {
        path: "/expense/boosting",
        title: "Boosting/Promotion",
        type: "link",
      },
      {
        path: "/expense/buy-products",
        title: "Buy Products",
        type: "link",
      },
      {
        path: "/expense/invest",
        title: "Invest",
        type: "link",
      },

      {
        title: "Loans",
        type: "sub",
        active: false,
        children: [
          {
            title: "Monthly",
            type: "link",
            path: "/expense/loans",
          },
          {
            title: "Customer wise",
            type: "link",
            path: "/expense/loans-by-customers",
          },
        ],
      },
      {
        path: "/expense/order",
        title: "All Sells",
        type: "link",
      },
      {
        path: "/expense/employee",
        title: "Employee",
        type: "link",
      },
    ],
  },

  {
    title: "Cash Summary",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      {
        path: "/cash-summary",
        title: "Monthly",
        type: "link",
      },
    ],
  },

  {
    title: "Products",
    icon: Box,
    type: "sub",
    active: false,
    children: [
      {
        path: "/products/physical/all-products",
        title: "All Products",
        type: "link",
      },

      {
        path: "/products/physical/add-product",
        title: "Add Product",
        type: "link",
      },
      {
        path: "/products/physical/brands",
        title: "Brands",
        type: "link",
      },
      {
        path: "/products/physical/categories",
        title: "Categories",
        type: "link",
      },
      {
        path: "/products/physical/campaigns",
        title: "Campaigns",
        type: "link",
      },
      {
        path: "/products/physical/banners",
        title: "Banners",
        type: "link",
      },
      {
        path: "/products/physical/shop-by-concern",
        title: "Shop By Concern",
        type: "link",
      },
      {
        path: "/products/physical/attributes",
        title: "Attributes",
        type: "link",
      },
      {
        path: "/products/physical/reviews",
        title: "Reviews",
        type: "link",
      },
      {
        path: "/products/physical/reviews-screenshot",
        title: "Review Screenshot",
        type: "link",
      },
      {
        path: "/products/physical/announcements",
        title: "Announcements",
        type: "link",
      },
    ],
  },

  {
    title: "Orders",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      { path: "/orders/Processing", title: "Processing", type: "link" },
      { path: "/orders/Confirmed", title: "Confirmed", type: "link" },
      { path: "/orders/Packing", title: "Packing", type: "link" },
      { path: "/orders/On the way", title: "On the way", type: "link" },
      {
        path: "/orders/Delivered",
        title: "Delivered",
        type: "link",
      },
      {
        path: "/orders/Partial Delivered",
        title: "Partial Delivered",
        type: "link",
      },
      {
        path: "/orders/Cancelled",
        title: "Cancelled",
        type: "link",
      },
      {
        path: "/orders/All Orders",
        title: "All Orders",
        type: "link",
      },
    ],
  },

  {
    title: "Users",
    icon: UserPlus,
    type: "sub",
    active: false,
    children: [
      { path: "/users/list-user", title: "User List", type: "link" },
      // { path: '/users/create-user', title: 'Create User', type: 'link' },
    ],
  },
];

export const MENUITEMSFOROFFICERS = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: Home,
    type: "link",
    badgeType: "primary",
    active: false,
  },
  {
    title: "Cash in/Cash out",
    icon: DollarSign,
    type: "sub",
    active: false,
    children: [
      {
        path: "/expense/daily-expense",
        title: new Date().toDateString(),
        type: "link",
      },
      {
        path: "/expense/expense-history",
        title: "History",
        type: "link",
      },

      {
        path: "/expense/office",
        title: "Office",
        type: "link",
      },

      {
        path: "/expense/salary",
        title: "Salary",
        type: "link",
      },
      {
        path: "/expense/refunds",
        title: "Refund",
        type: "link",
      },
      {
        path: "/expense/daily-cost",
        title: "Daily Cost",
        type: "link",
      },
      {
        path: "/expense/lot-transport",
        title: "Transport",
        type: "link",
      },
      {
        path: "/expense/courier",
        title: "Courier Charge",
        type: "link",
      },
      {
        path: "/expense/shipping",
        title: "Shipping",
        type: "link",
      },
      {
        path: "/expense/boosting",
        title: "Boosting/Promotion",
        type: "link",
      },
      {
        path: "/expense/buy-products",
        title: "Buy Products",
        type: "link",
      },
      {
        path: "/expense/invest",
        title: "Invest",
        type: "link",
      },

      {
        title: "Loans",
        type: "sub",
        active: false,
        children: [
          {
            title: "Monthly",
            type: "link",
            path: "/expense/loans",
          },
          {
            title: "Customer wise",
            type: "link",
            path: "/expense/loans-by-customers",
          },
        ],
      },
      {
        path: "/expense/order",
        title: "All Sells",
        type: "link",
      },
      {
        path: "/expense/employee",
        title: "Employee",
        type: "link",
      },
    ],
  },

  {
    title: "Cash Summary",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      {
        path: "/cash-summary",
        title: "Monthly",
        type: "link",
      },
    ],
  },

  {
    title: "Products",
    icon: Box,
    type: "sub",
    active: false,
    children: [
      {
        path: "/products/physical/all-products",
        title: "All Products",
        type: "link",
      },

      {
        path: "/products/physical/add-product",
        title: "Add Product",
        type: "link",
      },
      {
        path: "/products/physical/brands",
        title: "Brands",
        type: "link",
      },
      {
        path: "/products/physical/categories",
        title: "Categories",
        type: "link",
      },
      {
        path: "/products/physical/campaigns",
        title: "Campaigns",
        type: "link",
      },
      {
        path: "/products/physical/banners",
        title: "Banners",
        type: "link",
      },
      {
        path: "/products/physical/shop-by-concern",
        title: "Shop By Concern",
        type: "link",
      },
      {
        path: "/products/physical/attributes",
        title: "Attributes",
        type: "link",
      },
      {
        path: "/products/physical/reviews",
        title: "Reviews",
        type: "link",
      },
      {
        path: "/products/physical/reviews-screenshot",
        title: "Review Screenshot",
        type: "link",
      },
      {
        path: "/products/physical/announcements",
        title: "Announcements",
        type: "link",
      },
    ],
  },

  {
    title: "Orders",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      { path: "/orders/Processing", title: "Processing", type: "link" },
      { path: "/orders/Confirmed", title: "Confirmed", type: "link" },
      { path: "/orders/Packing", title: "Packing", type: "link" },
      { path: "/orders/On the way", title: "On the way", type: "link" },
      {
        path: "/orders/Delivered",
        title: "Delivered",
        type: "link",
      },
      {
        path: "/orders/Partial Delivered",
        title: "Partial Delivered",
        type: "link",
      },
      {
        path: "/orders/Cancelled",
        title: "Cancelled",
        type: "link",
      },
      {
        path: "/orders/All Orders",
        title: "All Orders",
        type: "link",
      },
    ],
  },

  {
    title: "Users",
    icon: UserPlus,
    type: "sub",
    active: false,
    children: [
      { path: "/users/list-user", title: "User List", type: "link" },
      // { path: '/users/create-user', title: 'Create User', type: 'link' },
    ],
  },
];
